import { render, staticRenderFns } from "./FloatingBootcampButton.vue?vue&type=template&id=571cb6a2&scoped=true&"
import script from "./FloatingBootcampButton.vue?vue&type=script&lang=js&"
export * from "./FloatingBootcampButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingBootcampButton.vue?vue&type=style&index=0&id=571cb6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571cb6a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout})
